'use strict';

/**
 * @template T
 * @typedef {Object} Peek
 * @property {() => IteratorResult<T, void>} peek
 */

/**
 * @template T
 * @typedef {Object} AsyncPeek
 * @property {() => Promise<IteratorResult<T, void>>} peek
 */

/**
 * @template T
 * @typedef {Object} Push
 * @property {(value:T) => void} push
 */

/**
 * @template T
 * @typedef {Iterable<T> & Peek<T> & Push<T> & Iterator<T>} Peekable<T>
 */

/**
 * @template T
 * @typedef {AsyncIterable<T> & AsyncPeek<T> & Push<T> & AsyncIterator<T>} AsyncPeekable<T>
 */

/**
 * @template {Iterable<any> | AsyncIterable<any>} I
 * @param {I} iterable
 * @returns {I extends Iterable<infer T>
 *  ? Peekable<T>
 *  : I extends AsyncIterable<infer T>
 *  ? AsyncPeekable<T>
 *  : never
 * }
 */
var _defineProperty = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function peekableIterator(iterable) {
  // @ts-ignore
  var _ref = iterable[Symbol.asyncIterator]
    // @ts-ignore
    ? [iterable[Symbol.asyncIterator](), Symbol.asyncIterator]
    // @ts-ignore
    : [iterable[Symbol.iterator](), Symbol.iterator],
    _ref2 = _slicedToArray(_ref, 2),
    iterator = _ref2[0],
    symbol = _ref2[1];

  /** @type {any[]} */
  var queue = [];

  // @ts-ignore
  return _defineProperty({
    peek: function peek() {
      return iterator.next();
    },
    push: function push(value) {
      queue.push(value);
    },
    next: function next() {
      if (queue.length) {
        return {
          done: false,
          value: queue.shift()
        };
      }
      return iterator.next();
    }
  }, symbol, function () {
    return this;
  });
}
module.exports = peekableIterator;